import client from '@/api/client.js';
import leadTypeApi from '@/api/Methods/Lead/Lead-Type-API-Methods';
import i18n from '@/plugins/i18n.js';
import store from "@/store";


export default {
    methods: {
        async toggleLeadsEnabled() {
            var meta = {
                clientApiMethod: 'toggleLeadsEnabled',
                input: {},
                successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.setting.setting") })
            }
            var response = await client().post(store.state.apiRouteRoot + "Lead/ToggleFeature", null, { meta: meta })
            return response?.data;
        },

        async getLeadListFromFilter(filter, cancelationToken) {
            var meta = { clientApiMethod: 'getLeadListFromFilter', input: { filter: filter } }
            var response = await client().get(store.state.apiRouteRoot + "Lead/Filtered", { params: filter, signal: cancelationToken, meta: meta })
            return response?.data;
        },

        async getLead(leadId) {
            var meta = { clientApiMethod: 'getLead', input: { leadId: leadId } }
            var response = await client().get(store.state.apiRouteRoot + "Lead/" + leadId, { meta: meta })
            return response?.data;
        },

        async createLead(newLead) {
            var meta = {
                clientApiMethod: 'createLead',
                input: { newLead },
                successText: i18n.t("servicesystem.responses.created_object", { okey: i18n.t("servicesystem.common_objects.lead.lead") })
            }
            var response = await client().post(store.state.apiRouteRoot + 'Lead', newLead, { meta: meta })
            return response?.data;
        },

        async changeLead(updatedLead) {
            var meta = {
                clientApiMethod: 'changeLead',
                input: { updatedLead },
                successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.lead.lead") })
            }
            var response = await client().patch(store.state.apiRouteRoot + 'Lead', updatedLead, { meta: meta })
            return response?.data;
        },

        async deleteLead(leadId) {
            var meta = {
                clientApiMethod: 'deleteLead',
                input: { leadId: leadId },
                successText: i18n.t("servicesystem.responses.removed_object", { okey: i18n.t("servicesystem.common_objects.lead.lead") })
            }
            var response = await client().delete(store.state.apiRouteRoot + "Lead/" + leadId, { meta: meta })
            return response?.data;
        },

        ...leadTypeApi.methods,
    }
}